import { GetTable } from "../../common/components/DataTable"
import React from "react"
import { attach } from "../../common/componentExtensions";
import { CaldaiaDto } from "../../generated";
import Actions from "../caldaieActions";
import Store from "../caldaieImportStore";
import { uniqWith } from "lodash";
import { Loading } from "../../common/components/loading";

const Table = GetTable<CaldaiaDto>();

const CaldaieByMarcaImportTable = (props: {
    marca: string;
    onSelectionChanged: (data: CaldaiaDto[]) => void;
    selection: CaldaiaDto[];
    data: CaldaiaDto[] | null;
}) => {
    React.useEffect(() => {
        Actions.getListaNuoveCaldaiePrecaricate(props.marca);
    }, [props.marca])

    if (props.marca && props.data == null)
        return <Loading />

    if (props.data != null && props.data.length === 0) {
        return <div className="alert alert-info">Disponi di tutti i modelli disponibili per la marca {props.marca}</div>
    }

    return <>
        <h3>Elenco modelli disponibili da importare</h3>
        <Table
            data={uniqWith(
                props.data ?? [],
                (x, y) => x.marcaCaldaia == y.marcaCaldaia && x.modelloCaldaia == y.modelloCaldaia && x.potenzaFocolare == y.potenzaFocolare && x.potenzaUtile == y.potenzaUtile)
                .sort((a, b) => (a.modelloCaldaia ?? "") > (b.modelloCaldaia ?? "") ? 1 : -1
                )}
            keySelector={x => `${x.marcaCaldaia}-${x.modelloCaldaia}-${x.potenzaFocolare}-${x.potenzaUtile}`}
            filterables={[x => x.marcaCaldaia, x => x.modelloCaldaia]}
        >
            <Table.SelectColumn
                selectedItems={props.selection}
                onSelectionChanged={props.onSelectionChanged}
            />
            <Table.Column template={x => x.marcaCaldaia} header="Marca" />
            <Table.Column template={x => x.modelloCaldaia} header="Modello" />
            <Table.Column
                header="Focolare"
                template={x => x.potenzaFocolare && x.potenzaFocolare > 0 ? x.potenzaFocolare : "N.C."}
            />
            <Table.Column
                header="Utile"
                template={x => x.potenzaUtile && x.potenzaUtile > 0 ? x.potenzaUtile : "N.C."}
            />            
        </Table>
    </>
}

export default attach(
    CaldaieByMarcaImportTable,
    Store,
    (store, props) => ({
        data: store.get(props.marca)
    })
);
